import { ServiceCategoryResponse } from "../models/service-category-response";
import { get } from "./utils";

export const getServiceCategories = async (url: string) => await get<ServiceCategoryResponse[]>(url, true);
